export default () => ({
  rows: [],
  row: null,
});
